import { required } from "vuelidate/lib/validators";
const satdosyafirmafiyat = {
  data() {
    return {
      satdosyafirmafiyatData: {
        Birimfiyat: "",
        Dosyafirmaid: "",
        Dosyamalzemeid: "", 
        Firmaturu:0,
        Yerlimi:false,
        Deleted: false,
      },
      FormDataType: {
        Birimfiyat: {
          FieldName: "Birimfiyat",
          Field: "input",
          FieldTitle: this.$t("satdosyafirmafiyat.AddEdit.Birimfiyat"),
          FieldType: "text", 
        },
        Yerlimi: {
          FieldName: "Yerlimi",
          Field: "checbox",
          FieldTitle: this.$t("satdosyafirmafiyat.AddEdit.Yerlimi"),
          FieldType: "text", 
        },
      },
    };
  },
  validations: {
    FormData: {
      Birimfiyat: { required },
      Yerlimi: {  },
    },
  }, 
};
export default satdosyafirmafiyat;
